import React from 'react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import InteractiveLLM from './InteractiveLLM';
import Concealment from './Concealment';
import EnvironmentAttacksRL from './EnvironmentAttacksRL';
import InverseConstraintRL from './InverseConstraintRL';
import MultilingualReasoning from './MultilingualReasoning';

/*
const papers = {
  selected: [
    {
      title: 'Example Paper Title Goes Here',
      authors: 'Kunwar Nir, Collaborator One, Collaborator Two',
      venue: 'arXiv preprint arXiv:XXXX.XXXXX, 2025',
      url: '#',
    },
  ],
  other: [
    {
      title: 'Another Paper Title Goes Here',
      authors: 'Collaborator One, Kunwar Nir, Collaborator Two',
      venue: 'arXiv preprint arXiv:XXXX.XXXXX, 2024',
      url: '#',
    },
  ],
};

function PaperCard({ title, authors, venue, url }: typeof papers.selected[0]) {
  return (
    <div className="paper-card">
      <a href={url} className="paper-title" target="_blank" rel="noreferrer">{title}</a>
      <p className="paper-authors" dangerouslySetInnerHTML={{
        __html: authors.replace('Kunwar Nir', '<strong>Kunwar Nir</strong>')
      }} />
      <p className="paper-venue">{venue}</p>
    </div>
  );
}
*/

function Header() {
  const location = useLocation();

  return (
    <header className="header">
      <div className="container header-inner">
        <Link className="site-name" to="/">Kunwar Nir</Link>
        <nav className="nav">
          <Link
            className={`nav-link${location.pathname === '/' ? ' nav-active' : ''}`}
            to="/"
          >About</Link>
          <Link
            className={`nav-link${location.pathname.startsWith('/research') ? ' nav-active' : ''}`}
            to="/research"
          >Research</Link>
        </nav>
      </div>
    </header>
  );
}

function AboutPage() {
  return (
    <main className="content">
      <h2 className="page-heading">About</h2>
      <p className="section-text">Computer Science Student at Carleton University.</p>
      <div className="links" style={{ marginTop: '16px' }}>
        <a href="https://github.com/kunwar45" target="_blank" rel="noreferrer" className="link">github</a>
        <span className="separator">{'// '}</span>
        <a href="https://www.linkedin.com/in/kunwarnir/" target="_blank" rel="noreferrer" className="link">linkedin</a>
        <span className="separator">{'// '}</span>
        <a href="mailto:knir45@gmail.com" className="link">email</a>
      </div>
    </main>
  );
}

function ResearchPage() {
  return (
    <main className="content">
      <h2 className="page-heading">Research</h2>
      {/* <p className="section-text">
        For a full list of publications, see my{' '}
        <a href="https://scholar.google.com" target="_blank" rel="noreferrer" className="link">Google Scholar</a>.
      </p>

      <h3 className="papers-subheading">Selected papers</h3>
      <div className="papers-list">
        {papers.selected.map((p, i) => <PaperCard key={i} {...p} />)}
      </div>

      <h3 className="papers-subheading">Other papers</h3>
      <div className="papers-list">
        {papers.other.map((p, i) => <PaperCard key={i} {...p} />)}
      </div> */}

      <h3 className="papers-subheading">Blog posts</h3>
      <div className="papers-list">
        {/* <div className="paper-card">
          <Link className="blog-post-title" to="/interactive-llm">
            Interactive LLM
          </Link>
          <p className="paper-venue">April 2026</p>
        </div> */}
        <div className="paper-card">
          <Link className="blog-post-title" to="/implicit-concealment-in-llms">
            Implicit Concealment in LLM Agents
          </Link>
          <p className="paper-venue">April 2026</p>
        </div>
        {/* <div className="paper-card">
          <Link className="blog-post-title" to="/environment-attacks-rl">
            Training-Time Environment Attacks for RL
          </Link>
          <p className="paper-venue">Honours Thesis · Carleton University</p>
        </div> */}
<div className="paper-card">
          <Link className="blog-post-title" to="/multilingual-reasoning">
            Causal Analysis of Multilingual Reasoning
          </Link>
          {/* <p className="paper-venue"></p> */}
        </div>
      </div>
    </main>
  );
}


function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <div className="container">
          <Routes>
            <Route path="/" element={<AboutPage />} />
            <Route path="/research" element={<ResearchPage />} />
            <Route path="/interactive-llm" element={<InteractiveLLM />} />
            <Route path="/implicit-concealment-in-llms" element={<Concealment />} />
            <Route path="/environment-attacks-rl" element={<EnvironmentAttacksRL />} />
            <Route path="/inverse-constraint-rl" element={<InverseConstraintRL />} />
            <Route path="/multilingual-reasoning" element={<MultilingualReasoning />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
